// Auto-generated language file from /opt/wh/whtree/modules/publisher/js/captcha/__captcha.lang.json
var registerTexts = require("@mod-tollium/js/gettid").registerTexts;
registerTexts("publisher","nl",{"site":{"captcha":{"explain":"Vink het vakje hieronder aan","title":"Verificatie"}}});
// Adding dependency: /opt/wh/whtree/modules/publisher/language/nl.xml
